<template>
  <div class="grid-view">
    <div class="results">
      <div
        class="result"
        v-for="recipe in data"
        :key="`${recipe.categoryKey}-${recipe.key}`"
      >
        <related-item
          :recipeKey="recipe.key"
          :categoryKey="recipe.categoryKey"
          :name="recipe.name"
          :imageUrl="recipe.imageUrl"
          @click="onClick"
        />
      </div>
    </div>
  </div>
</template>

<script>
  import RelatedItem from "../../views/Recipes/components/RelatedItem";

  export default {
    name: "GridView",
    components: { RelatedItem },
    props: {
      data: {
        type: Array,
        required: true
      },
    },
    methods: {
      onClick(recipe) {
        this.$emit("view", recipe);
      }
    }
  };
</script>

<style scoped lang="scss">
  .grid-view {
    display: flex;
    flex-direction: column;

    .results {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      margin: 0 -1%;

      .result {
        display: flex;
        flex-direction: column;
        flex: 0 1 23%;
        margin: 1%;

        .related-item {
          flex-grow: 1;
          border-radius: $radius;
        }
      }

      @media (max-width: $media-extra-large) {
        .result {
          flex: 0 1 31.3333%;
        }
      }

      @media (max-width: $media-medium) {
        .result {
          flex: 0 1 48%;
        }
      }

      @media (max-width: $media-small) {
        flex-direction: column;
        margin: 0 -16px;
      }
    }
  }
</style>
